// extracted by mini-css-extract-plugin
export default {"modal":"batching-failure-modal_modal__5a894"};